/* Earth Arts Pottery Studio — minimal theme behaviors */
(function () {
  'use strict';

  // ---- Location lens (TRANSIENT) ------------------------------------------
  // ?loc=<handle> applies a soft lens to the CURRENT page view only
  // (e.g. /pages/experiences?loc=garden-city) — it is never persisted.
  // Broadcasts 'eaps:location' CustomEvent + sets <html data-eaps-location>.
  // The header studio menu is plain navigation (see header.liquid); the old
  // persistent preference was retired 2026-07 — LOC_KEY exists only so we
  // can clean up legacy keys on returning visitors.
  var LOC_KEY = 'eaps:location';
  function eapsGetLocation() {
    try { return new URLSearchParams(window.location.search).get('loc') || ''; } catch (e) { return ''; }
  }
  function eapsBroadcast(id) {
    document.documentElement.setAttribute('data-eaps-location', id || '');
    try {
      window.dispatchEvent(new CustomEvent('eaps:location', { detail: { id: id || '' } }));
    } catch (e) {}
  }
  window.EAPS = window.EAPS || {};
  window.EAPS.getLocation = eapsGetLocation;

  // Mobile nav drawer
  function initDrawer() {
    var openBtn = document.querySelector('[data-drawer-open]');
    var drawer = document.querySelector('[data-drawer]');
    if (!openBtn || !drawer) return;

    function open() { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; document.documentElement.classList.add('ea-drawer-lock'); }
    function close() { drawer.removeAttribute('open'); document.body.style.overflow = ''; document.documentElement.classList.remove('ea-drawer-lock'); }

    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  // Product gallery thumbnail swap
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (src) main.setAttribute('src', src);
      });
    });
  }

  // Quantity stepper
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = val;
        });
      });
    });
  }

  // Dialog modals with focus trap + restore
  function initModals() {
    var openers = document.querySelectorAll('[data-modal-open]');
    if (!openers.length) return;
    var lastOpener = null;

    function getFocusable(modal) {
      return Array.prototype.slice.call(modal.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
    }

    function openModal(modal, opener) {
      lastOpener = opener || null;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var focusable = getFocusable(modal);
      (focusable[0] || modal).focus();
    }

    function closeModal(modal) {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastOpener) {
        lastOpener.setAttribute('aria-expanded', 'false');
        if (lastOpener.focus) lastOpener.focus();
        lastOpener = null;
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.getElementById(btn.getAttribute('data-modal-open'));
        if (modal) openModal(modal, btn);
      });
    });

    document.querySelectorAll('[data-modal]').forEach(function (modal) {
      modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeModal(modal); });
      });
    });

    document.addEventListener('keydown', function (e) {
      var open = document.querySelector('[data-modal]:not([hidden])');
      if (!open) return;
      if (e.key === 'Escape') { closeModal(open); return; }
      if (e.key === 'Tab') {
        var focusable = getFocusable(open);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });
  }

  // Featured experience cross-dissolve carousel
  function initFeatured() {
    document.querySelectorAll('[data-featured]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-featured-slide]');
      if (slides.length < 2) return;
      var dots = root.querySelectorAll('[data-featured-dot]');
      var prev = root.querySelector('[data-featured-prev]');
      var next = root.querySelector('[data-featured-next]');
      var i = 0, timer = null;

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) {
          var on = idx === i;
          d.classList.toggle('is-active', on);
          if (on) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); timer = setInterval(function () { show(i + 1); }, 6000); }

      if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
      if (next) next.addEventListener('click', function () { show(i + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-featured-dot'), 10)); start(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      show(0);
      start();
    });
  }

  // Rotating content per visit (localStorage), mirrors React storefront
  function nextRotating(key, length) {
    if (length <= 1) return 0;
    try {
      var prev = Number(window.localStorage.getItem(key));
      var base = Number.isInteger(prev) && prev >= 0 ? prev : -1;
      var next = (base + 1) % length;
      window.localStorage.setItem(key, String(next));
      return next;
    } catch (e) {
      return Math.floor(Math.random() * length);
    }
  }

  function parseRotate(el, attr) {
    if (!el) return null;
    try {
      var list = JSON.parse(el.getAttribute(attr));
      return Array.isArray(list) && list.length ? list : null;
    } catch (e) { return null; }
  }

  function initHeroRotation() {
    var el = document.querySelector('[data-hero-rotate]');
    var list = parseRotate(el, 'data-hero-rotate');
    if (!list) return;
    var pick = list[nextRotating('eaps:hero', list.length)];
    if (!pick || !pick.src) return;
    el.src = pick.src;
    if (pick.position) el.style.objectPosition = pick.position;
  }

  function initGiftRotation() {
    var el = document.querySelector('[data-gift-rotate]');
    var list = parseRotate(el, 'data-gift-rotate');
    if (!list) return;
    var pick = list[nextRotating('eaps:gift', list.length)];
    if (!pick) return;
    var lead = el.querySelector('.ea-gift__title-lead');
    var em = el.querySelector('.ea-gift__title-em');
    if (lead && pick.lead) lead.textContent = pick.lead;
    if (em && pick.tail) em.textContent = pick.tail;
  }

  // EAPS Shapes — subtle sitewide canvas pebbles.
  // Every real page load/refresh advances the shape/color set so the canvas feels alive.
  function initEapsShapes() {
    var root = document.querySelector('.content-for-layout');
    if (!root) return;

    var shapes = ['primary', 'round', 'cloud', 'faceted'];
    // Flat raw-fired EAPS palette: brand-adjacent earth colors, no gradients, no 3D treatment.
    var colors = ['#c8a46e', '#b9826f', '#aab7a2', '#b9c8c5', '#c88472', '#9fa786', '#d6b8a3', '#b7997d', '#d2aaa0'];
    var existing = root.querySelectorAll('.ea-canvas-shape');
    Array.prototype.forEach.call(existing, function (el) { el.remove(); });

    function n(min, max) { return min + Math.random() * (max - min); }

    function protectedTextRects() {
      var isMobile = window.innerWidth < 860;
      // Mobile should read as edge/void pebbles, not pebbles behind copy. Desktop can be a little looser.
      var textSelectors = [
        'h1','h2','h3','.ea-hero__title','.hero-clean h1','.ea-cat__head',
        '.ea-featured__title','.ea-featured__body','.ea-featured__price',
        '.ea-gift__title','.ea-gift__body',
        '.ea-card__title','.ea-card__price','.price','.price-item','[class*="__price"]','[id^="price-"]',
        '.rb__title','.rb__lede','.rb__price','.rb__summary','.rb__total','.rb__cta',
        '.tr__title','.tr__lede','.tr__summary','.tr__cta',
        '.ea-cathero__title','.ea-cathero__body','.ea-cathero__promise',
        '.ea-btn-rust','.ea-btn-cream','button[type="submit"]'
      ];
      textSelectors = textSelectors.concat([
        'main p','main li','main label','main input','main select','main textarea',
        '.ea-card','.ea-bk','.ea-featured__text','.ea-gift__grid','.ea-shop-rail .ea-card',
        '.rb__panel','.rb__booking','.rb__identity-meta','.rb__identity-price','.rb__identity-price *',
        '.tr__panel','.tr__booking','.tr__facts','.tr__fact',
        '.rb__carousel-control','.rb__carousel-control *','.ea-header','.ea-announce',
        '.ea-locsel','.ea-locsel *'
      ]);
      return Array.prototype.slice.call(document.querySelectorAll(textSelectors.join(','))).filter(function (el) {
        if (el.closest('.ea-bnd,.ea-drawer')) return false;
        var style = window.getComputedStyle(el);
        if (style.visibility === 'hidden' || style.display === 'none') return false;
        var r = el.getBoundingClientRect();
        return r.width > 18 && r.height > 10;
      }).map(function (el) {
        var r = el.getBoundingClientRect();
        var cls = String(el.className || '');
        var text = (el.textContent || '').trim();
        var critical = cls.indexOf('price') !== -1 || /\$\d|price|total/i.test(text) || el.matches('.ea-featured__price,.ea-card__price,.price,.price-item,[class*="__price"],[id^="price-"],.ea-btn-rust,.ea-btn-cream,button[type="submit"]');
        var buffer = critical ? (isMobile ? 54 : 42) : (isMobile ? 22 : 28);
        return {
          left: r.left + window.scrollX - buffer,
          right: r.right + window.scrollX + buffer,
          top: r.top + window.scrollY - buffer,
          bottom: r.bottom + window.scrollY + buffer,
          critical: critical || isMobile
        };
      });
    }

    function collisionArea(a, b) {
      var overlapX = Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left));
      var overlapY = Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
      return overlapX * overlapY;
    }

    function rectsCollide(a, b) {
      var area = collisionArea(a, b);
      return b.critical ? area > 0 : area > 900;
    }

    function nextVisit() {
      var key = 'eaps:shape-visit';
      var value = Date.now() % 100000;
      try {
        value = (parseInt(window.localStorage.getItem(key), 10) || 0) + 1;
        window.localStorage.setItem(key, String(value));
      } catch (e) {}
      return value;
    }

    var visit = nextVisit();
    var randomSalt = Math.floor(Math.random() * 1000000);
    var h = Math.max(root.scrollHeight || 0, window.innerHeight * 1.4);
    var isMobile = window.innerWidth < 860;
    var isReserveLike = !!document.querySelector('[data-table-reserve], [data-eaps-event-booking], [data-camp-reserve]') || window.location.pathname.indexOf('/products/') === 0;
    var isCategoryPage = !!document.querySelector('.ea-cathero');
    var count = isMobile ? Math.min(5, Math.max(3, Math.round(h / 1450))) : (isCategoryPage ? Math.min(6, Math.max(4, Math.round(h / 850))) : (h < 980 ? 5 : 7));
    var used = [];
    var placedGlobalBoxes = [];
    var protectedRects = protectedTextRects();
    var pageWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var rootTop = root.getBoundingClientRect().top + window.scrollY;

    function slotTop(i, size) {
      if (isMobile) {
        var mobileSlots = [720, 1180, 1700, 2280, 3060, 3920, 4880, 6100, 7420];
        var base = mobileSlots[i % mobileSlots.length] + Math.floor(i / mobileSlots.length) * 760;
        return Math.round(Math.max(80, Math.min(h - size - 36, base + n(-120, 140))));
      }
      if (isCategoryPage) {
        // Category heroes own the upper-right shape field. Keep global canvas pebbles away from the hero/first-card perimeter.
        var minTop = Math.min(Math.max(560, window.innerHeight * 0.58), Math.max(120, h - size - 48));
        var usable = Math.max(0, h - minTop - size - 72);
        return Math.round(Math.max(minTop, Math.min(h - size - 48, minTop + ((i + 0.55) / Math.max(1, count)) * usable + n(-90, 90))));
      }
      var band = (i + 0.42) / count;
      var jitter = isReserveLike ? n(-0.04, 0.04) : n(-0.065, 0.065);
      return Math.round(Math.max(120, Math.min(h - size - 48, (band + jitter) * h)));
    }

    function candidateFor(i, size) {
      var sideLeft = Math.random() > 0.5;
      var insetMin = isMobile ? -19 : (isCategoryPage ? -5.2 : -2.2);
      var insetMax = isMobile ? -9 : (isCategoryPage ? 3.2 : 6.2);
      return { top: slotTop(i, size), sideLeft: sideLeft, inset: n(insetMin, insetMax) };
    }

    function candidateBox(c, size) {
      var actualSize = isMobile ? size * 0.88 : size;
      var insetPx = pageWidth * (c.inset / 100);
      var left = c.sideLeft ? insetPx : pageWidth - insetPx - actualSize;
      return { left: left, right: left + actualSize, top: rootTop + c.top, bottom: rootTop + c.top + actualSize };
    }

    function expandedBox(box, gap) {
      return { left: box.left - gap, right: box.right + gap, top: box.top - gap, bottom: box.bottom + gap };
    }

    function scoreCandidate(box) {
      var penalty = 0;
      if (!isMobile) {
        protectedRects.forEach(function (t) {
          var area = collisionArea(box, t);
          if (area) penalty += area * 1000;
        });
      }
      placedGlobalBoxes.forEach(function (p) {
        if (collisionArea(expandedBox(box, isMobile ? 10 : 18), expandedBox(p, isMobile ? 10 : 18)) > 0) penalty += 100000000;
      });
      return penalty;
    }

    for (var i = 0; i < count; i++) {
      var shape = shapes[(visit + randomSalt + i) % shapes.length];
      var color = colors[(visit + randomSalt + i * 5) % colors.length];
      var size = Math.round(isMobile ? n(i === 0 ? 116 : 92, i === 0 ? 154 : 126) : (isCategoryPage ? n(i === 0 ? 112 : 82, i === 0 ? 154 : 132) : n(i === 0 ? 148 : 96, i === 0 ? 210 : 158))); 
      var c = candidateFor(i, size);
      var best = c;
      var bestScore = scoreCandidate(candidateBox(c, size));
      for (var attempt = 0; attempt < (isMobile ? 90 : (isCategoryPage ? 90 : 32)); attempt++) {
        var tryCandidate = candidateFor(i, size);
        var tryBox = candidateBox(tryCandidate, size);
        var tryScore = scoreCandidate(tryBox);
        if (tryScore < bestScore) {
          best = tryCandidate;
          bestScore = tryScore;
        }
        if (isMobile || !protectedRects.some(function (t) { return rectsCollide(tryBox, t); })) {
          best = tryCandidate;
          bestScore = 0;
          break;
        }
      }
      // If this band has no real void, skip the pebble instead of placing it under text/pricing.
      if (bestScore > 0) continue;
      c = best;
      used.push(shape + ':' + color + ':' + Math.round(c.top) + ':' + (c.sideLeft ? 'L' : 'R') + ':' + c.inset.toFixed(1));
      var el = document.createElement('span');
      el.className = 'ea-canvas-shape ea-canvas-shape--' + shape;
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-shape', shape);
      el.setAttribute('data-color', color);
      el.setAttribute('data-shape-signature', used[used.length - 1]);
      el.style.setProperty('--ea-canvas-shape-url', 'var(--ea-shape-' + shape + ')');
      el.style.setProperty('--ea-canvas-color', color);
      el.style.setProperty('--ea-canvas-size', size + 'px');
      el.style.setProperty('--ea-canvas-top', c.top + 'px');
      el.style.setProperty('--ea-canvas-left', c.sideLeft ? c.inset.toFixed(1) + 'vw' : 'auto');
      el.style.setProperty('--ea-canvas-right', c.sideLeft ? 'auto' : c.inset.toFixed(1) + 'vw');
      el.style.setProperty('--ea-canvas-rotate', Math.round(n(-10, 10)) + 'deg');
      root.insertBefore(el, root.firstChild);
      placedGlobalBoxes.push(candidateBox(c, size));
    }

    function docBox(el) {
      var r = el.getBoundingClientRect();
      return { left: r.left + window.scrollX, right: r.right + window.scrollX, top: r.top + window.scrollY, bottom: r.bottom + window.scrollY, width: r.width, height: r.height };
    }

    function overlapsPlaced(box, placed) {
      return placed.some(function (p) { return collisionArea(box, p) > 0; });
    }

    function randomizeCategoryHeroShapes() {
      document.querySelectorAll('[data-cathero]').forEach(function (host) {
        var local = Array.prototype.slice.call(host.querySelectorAll('.ea-cathero__pk'));
        if (!local.length) return;
        var used = [];
        local.forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.setAttribute('data-eaps-hidden-reason', isMobile ? 'mobile-hidden' : 'not-selected-this-load');
        });
        if (isMobile) {
          host.setAttribute('data-eaps-template-shapes', 'mobile-hidden');
          return;
        }
        var hostBox = docBox(host);
        var protectedNow = Array.prototype.slice.call(host.querySelectorAll('.ea-cathero__title,.ea-cathero__body,.ea-cathero__promise,.ea-cathero__open,.ea-cathero__ctas')).filter(function (el) {
          var cs = window.getComputedStyle(el);
          return cs.display !== 'none' && cs.visibility !== 'hidden';
        }).map(function (el) { return expandedBox(docBox(el), 34); });
        var placed = Array.prototype.slice.call(document.querySelectorAll('.ea-canvas-shape')).map(function (el) { return expandedBox(docBox(el), 34); });
        var order = local.slice().sort(function () { return Math.random() - 0.5; });
        var shapeOrder = shapes.slice().sort(function () { return Math.random() - 0.5; });
        var colorOrder = colors.slice().sort(function () { return Math.random() - 0.5; });
        var slots = [
          { min: 176, max: 222, rightMin: 74, rightMax: 168, topMin: 30, topMax: 108 },
          { min: 92, max: 132, rightMin: 282, rightMax: 430, topMin: 166, topMax: 296 },
          { min: 64, max: 98, rightMin: 12, rightMax: 92, topMin: 218, topMax: 360 }
        ];
        for (var i = 0; i < Math.min(3, order.length); i++) {
          var el = order[i];
          var slot = slots[i];
          var best = null;
          var bestScore = Infinity;
          var size = 0;
          for (var attempt = 0; attempt < 110; attempt++) {
            size = Math.round(n(slot.min, slot.max));
            var right = n(slot.rightMin, slot.rightMax);
            var x = Math.max(0, hostBox.width - right - size);
            var y = n(slot.topMin, Math.min(slot.topMax, Math.max(slot.topMin + 8, hostBox.height - size - 24)));
            var box = { left: hostBox.left + x, right: hostBox.left + x + size, top: hostBox.top + y, bottom: hostBox.top + y + size };
            var score = 0;
            protectedNow.forEach(function (t) {
              var area = collisionArea(box, t);
              if (area) score += area * 1000;
            });
            if (overlapsPlaced(expandedBox(box, 34), placed)) score += 100000000;
            if (score < bestScore) { best = { x: x, y: y, box: box, size: size }; bestScore = score; }
            if (score === 0) break;
          }
          if (!best || bestScore > 0) continue;
          var shape = shapeOrder[i % shapeOrder.length];
          var color = colorOrder[i % colorOrder.length];
          var rotate = Math.round(n(-12, 12));
          el.setAttribute('data-shape', shape);
          el.setAttribute('data-color', color);
          el.setAttribute('data-shape-signature', shape + ':' + color + ':' + Math.round(best.x) + ':' + Math.round(best.y) + ':' + Math.round(best.size) + ':' + rotate);
          el.style.setProperty('display', 'block', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.width = best.size + 'px';
          el.style.height = best.size + 'px';
          el.style.left = Math.round(best.x) + 'px';
          el.style.top = Math.round(best.y) + 'px';
          el.style.right = 'auto';
          el.style.bottom = 'auto';
          el.style.setProperty('--pk-color', color);
          el.style.setProperty('--r', rotate + 'deg');
          var heroShapeUrl = host.getAttribute('data-shape-' + shape + '-url');
          var heroMask = heroShapeUrl ? 'url("' + heroShapeUrl.replace(/"/g, '%22') + '")' : 'var(--ea-shape-' + shape + ')';
          el.style.setProperty('-webkit-mask-image', heroMask);
          el.style.setProperty('mask-image', heroMask);
          el.removeAttribute('data-eaps-hidden-reason');
          placed.push(expandedBox(best.box, 34));
          used.push(el.getAttribute('data-shape-signature'));
        }
        host.setAttribute('data-eaps-template-shapes', used.join('|'));
      });
    }

    function placeTemplateShapes() {
      var placed = Array.prototype.slice.call(document.querySelectorAll('.ea-canvas-shape')).map(function (el) { return expandedBox(docBox(el), 18); });
      var protectedNow = protectedTextRects();
      var localShapes = Array.prototype.slice.call(document.querySelectorAll('.rb__shape,.tr__shape')); // category hero pebbles are randomized separately above
      var localUsed = [];
      localShapes.forEach(function (el, i) {
        if (window.getComputedStyle(el).display === 'none') return;
        var host = el.closest('[data-bta-reserve], [data-table-reserve], [data-cathero], .rb, .tr, .ea-cathero__inner') || el.offsetParent || root;
        var hostBox = docBox(host);
        var current = docBox(el);
        var size = Math.max(42, Math.min(Math.max(current.width, current.height) || (pageWidth < 860 ? 96 : 140), pageWidth < 860 ? 150 : 230));
        if (pageWidth < 860) size = Math.min(size, 118);
        var best = null;
        var bestScore = Infinity;
        for (var attempt = 0; attempt < 90; attempt++) {
          var sideLeft = Math.random() > 0.5;
          var bleed = n(pageWidth < 860 ? -0.28 : -0.18, pageWidth < 860 ? 0.06 : 0.08) * size;
          var x = sideLeft ? bleed : (hostBox.width - size - bleed);
          var yMin = pageWidth < 860 ? 70 : 90;
          var yMax = Math.max(yMin + 20, hostBox.height - size - (pageWidth < 860 ? 70 : 90));
          var y = n(yMin, yMax);
          var box = { left: hostBox.left + x, right: hostBox.left + x + size, top: hostBox.top + y, bottom: hostBox.top + y + size };
          var score = 0;
          protectedNow.forEach(function (t) {
            var area = collisionArea(box, t);
            if (area) score += area * 1000;
          });
          if (overlapsPlaced(expandedBox(box, 18), placed)) score += 100000000;
          if (score < bestScore) { best = { x: x, y: y, box: box, sideLeft: sideLeft }; bestScore = score; }
          if (score === 0) break;
        }
        if (!best || bestScore > 0) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.setAttribute('data-eaps-hidden-reason', 'no-safe-void');
          return;
        }
        var shape = shapes[(visit + randomSalt + i * 3 + 7) % shapes.length];
        var color = colors[(visit * 7 + randomSalt + i * 5 + 3) % colors.length];
        var maskUrl = '';
        var localRoot = el.closest('[data-bta-reserve], [data-table-reserve]');
        if (localRoot) {
          var shapeUrl = localRoot.getAttribute('data-shape-' + shape + '-url');
          if (shapeUrl) maskUrl = 'url("' + shapeUrl.replace(/"/g, '%22') + '")';
        }
        el.setAttribute('data-shape', shape);
        el.setAttribute('data-color', color);
        el.setAttribute('data-shape-signature', shape + ':' + color + ':' + Math.round(best.y) + ':' + (best.sideLeft ? 'L' : 'R') + ':' + Math.round(size));
        el.style.setProperty('--rb-shape-color', color);
        el.style.setProperty('--tr-shape-color', color);
        el.style.setProperty('--pk-color', color);
        el.style.setProperty('--rb-shape-size', Math.round(size) + 'px');
        el.style.width = Math.round(size) + 'px';
        el.style.height = Math.round(size) + 'px';
        el.style.left = Math.round(best.x) + 'px';
        el.style.top = Math.round(best.y) + 'px';
        el.style.right = 'auto';
        el.style.bottom = 'auto';
        el.style.setProperty('--rb-shape-left', Math.round(best.x) + 'px');
        el.style.setProperty('--rb-shape-top', Math.round(best.y) + 'px');
        el.style.setProperty('--rb-shape-right', 'auto');
        el.style.setProperty('--rb-shape-bottom', 'auto');
        el.style.setProperty('--rb-shape-rotate', Math.round(n(-10, 10)) + 'deg');
        el.style.setProperty('--r', Math.round(n(-10, 10)) + 'deg');
        if (maskUrl) {
          el.style.setProperty('-webkit-mask-image', maskUrl);
          el.style.setProperty('mask-image', maskUrl);
          el.style.setProperty('--rb-shape-url', maskUrl);
        } else {
          var heroShapeUrl = host.getAttribute('data-shape-' + shape + '-url');
          var heroMask = heroShapeUrl ? 'url("' + heroShapeUrl.replace(/"/g, '%22') + '")' : 'var(--ea-shape-' + shape + ')';
          el.style.setProperty('-webkit-mask-image', heroMask);
          el.style.setProperty('mask-image', heroMask);
        }
        el.style.visibility = 'visible';
        placed.push(expandedBox(best.box, 18));
        localUsed.push(el.getAttribute('data-shape-signature'));
      });
      document.querySelectorAll('[data-bta-reserve], [data-table-reserve]').forEach(function (host) {
        host.setAttribute('data-eaps-template-shapes', Array.prototype.slice.call(host.querySelectorAll('.rb__shape,.tr__shape')).map(function (el) { return el.getAttribute('data-shape-signature') || ''; }).filter(Boolean).join('|'));
      });
    }


    function pruneUnsafeRenderedShapes() {
      var safe = [];
      var protectedNow = protectedTextRects();
      Array.prototype.slice.call(document.querySelectorAll('.ea-cathero__pk,.ea-canvas-shape,.rb__shape,.tr__shape')).forEach(function (el) {
        var cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') return;
        var box = docBox(el);
        var unsafeText = (isMobile && el.matches('.ea-canvas-shape')) || el.matches('.ea-cathero__pk') ? false : protectedNow.some(function (t) { return collisionArea(box, t) > 0; });
        var shapeGap = el.matches('.ea-cathero__pk') ? 14 : 42;
        var unsafeShape = safe.some(function (p) { return collisionArea(expandedBox(box, shapeGap), expandedBox(p, shapeGap)) > 0; });
        if (unsafeText || unsafeShape) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.setAttribute('data-eaps-hidden-reason', unsafeText ? 'post-render-protected-overlap' : 'post-render-shape-overlap');
          return;
        }
        safe.push(box);
      });
      root.setAttribute('data-eaps-visible-shape-count', String(safe.length));
    }

    root.setAttribute('data-eaps-shapes', used.join('|'));
    root.setAttribute('data-eaps-shape-visit', String(visit));
    initEapsTemplateShapes(visit, shapes, colors);
    randomizeCategoryHeroShapes();
    placeTemplateShapes();
    pruneUnsafeRenderedShapes();
  }

  function initEapsTemplateShapes(visit, shapes, colors) {
    function absoluteMask(root, shape) {
      var shapeUrl = root.getAttribute('data-shape-' + shape + '-url');
      if (!shapeUrl) return '';
      return 'url("' + shapeUrl.replace(/"/g, '%22') + '")';
    }

    document.querySelectorAll('[data-table-reserve]').forEach(function (root) {
      var used = [];
      root.querySelectorAll('.tr__shape').forEach(function (el, i) {
        var shape = shapes[(visit + i + 1) % shapes.length];
        var color = colors[(visit * 3 + i * 4 + 1) % colors.length];
        var maskUrl = absoluteMask(root, shape);
        used.push(shape + ':' + color);
        el.setAttribute('data-shape', shape);
        el.setAttribute('data-color', color);
        if (maskUrl) {
          el.style.setProperty('-webkit-mask-image', maskUrl);
          el.style.setProperty('mask-image', maskUrl);
        }
        el.style.setProperty('--tr-shape-color', color);
      });
      root.setAttribute('data-eaps-template-shapes', used.join('|'));
    });

    document.querySelectorAll('[data-bta-reserve]').forEach(function (root) {
      var reserveColors = colors;
      var used = [];
      root.querySelectorAll('.rb__shape').forEach(function (el, i) {
        var shape = shapes[(visit + i + 2) % shapes.length];
        var color = reserveColors[(visit * 5 + i * 3 + 2) % reserveColors.length];
        var maskUrl = absoluteMask(root, shape);
        var rotate = ((visit * 11 + i * 17) % 24) - 12;
        used.push(shape + ':' + color);
        el.setAttribute('data-shape', shape);
        el.setAttribute('data-color', color);
        if (maskUrl) {
          el.style.setProperty('-webkit-mask-image', maskUrl);
          el.style.setProperty('mask-image', maskUrl);
          el.style.setProperty('--rb-shape-url', maskUrl);
        }
        el.style.setProperty('--rb-shape-color', color);
        el.style.setProperty('--rb-shape-rotate', rotate + 'deg');
      });
      root.setAttribute('data-eaps-template-shapes', used.join('|'));
    });
  }

  // Retired picker: purge any legacy saved preference, then broadcast the
  // transient ?loc= lens (if present) so listening sections can respond.
  function initLocsel() {
    try { window.localStorage.removeItem(LOC_KEY); } catch (e) {}
    var lens = eapsGetLocation();
    if (lens) eapsBroadcast(lens);
  }

  function initClayCanvas() {
    var root = document.documentElement;
    if (!root || !document.body) return;

    var lastSignature = '';
    function buildSpeckleField() {
      var width = Math.max(window.innerWidth || 0, document.documentElement.clientWidth || 0, 320);
      var height = Math.max(
        document.body.scrollHeight || 0,
        document.documentElement.scrollHeight || 0,
        window.innerHeight || 0,
        1600
      );
      width = Math.round(width);
      height = Math.round(height);
      var signature = width + 'x' + height;
      if (signature === lastSignature) return;
      lastSignature = signature;

      var area = width * height;
      var count = Math.max(280, Math.min(1050, Math.round(area / 9000)));
      var palette = [
        { fill: '#5a3822', opacity: 0.48, weight: 0.38 },
        { fill: '#7c5130', opacity: 0.42, weight: 0.30 },
        { fill: '#9b6f3d', opacity: 0.34, weight: 0.20 },
        { fill: '#6f4b31', opacity: 0.30, weight: 0.12 }
      ];

      function pickColor() {
        var roll = Math.random();
        var cursor = 0;
        for (var i = 0; i < palette.length; i += 1) {
          cursor += palette[i].weight;
          if (roll <= cursor) return palette[i];
        }
        return palette[0];
      }

      function size() {
        var roll = Math.random();
        if (roll > 0.985) return 2.5 + Math.random() * 1.8;
        if (roll > 0.88) return 1.35 + Math.random() * 1.05;
        return 0.55 + Math.random() * 0.8;
      }

      function blobPath(cx, cy, base) {
        var points = 6 + Math.floor(Math.random() * 3);
        var d = '';
        var rotation = Math.random() * Math.PI * 2;
        for (var i = 0; i < points; i += 1) {
          var angle = rotation + (Math.PI * 2 * i / points);
          var r = base * (0.68 + Math.random() * 0.58);
          var x = (cx + Math.cos(angle) * r).toFixed(2);
          var y = (cy + Math.sin(angle) * r * (0.82 + Math.random() * 0.32)).toFixed(2);
          d += (i === 0 ? 'M' : 'L') + x + ' ' + y + ' ';
        }
        return d + 'Z';
      }

      var speckles = [];
      for (var n = 0; n < count; n += 1) {
        var color = pickColor();
        var x = Math.round(18 + Math.random() * Math.max(1, width - 36));
        var y = Math.round(18 + Math.random() * Math.max(1, height - 36));
        var r = size();
        if (Math.random() > 0.58) {
          speckles.push(
            '<path d="' + blobPath(x, y, r) + '" fill="' + color.fill + '" fill-opacity="' + color.opacity + '"/>'
          );
        } else {
          var rx = (r * (0.75 + Math.random() * 0.7)).toFixed(2);
          var ry = (r * (0.58 + Math.random() * 0.62)).toFixed(2);
          var rot = Math.round(Math.random() * 180);
          speckles.push(
            '<ellipse cx="' + x + '" cy="' + y + '" rx="' + rx + '" ry="' + ry + '" transform="rotate(' + rot + ' ' + x + ' ' + y + ')" fill="' + color.fill + '" fill-opacity="' + color.opacity + '"/>'
          );
        }
      }

      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '" viewBox="0 0 ' + width + ' ' + height + '">' + speckles.join('') + '</svg>';
      root.style.setProperty('--ea-clay-speckle-image', 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")');
    }

    buildSpeckleField();
    window.addEventListener('load', buildSpeckleField, { once: true });
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(buildSpeckleField, 120);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initClayCanvas();
    initDrawer();
    initGallery();
    initQty();
    initModals();
    initFeatured();
    initHeroRotation();
    initGiftRotation();
    initLocsel();
    // Place shapes with the rest of the first interactive paint. Do not wait for a delayed
    // post-load pass: the late pop-in feels jolting, especially on mobile.
    window.requestAnimationFrame(initEapsShapes);
  });
})();
